import { useState, useEffect } from 'react';
import { useToggle } from 'react-use';

export default function useCollectionsFetch (refs, dependencies = [], { detail = false } = {}) {
  const [items, setItems] = useState([]);
  const [isLoading, toggleLoading] = useToggle(false);
  useEffect(() => {
    (async () => {
      try {
        toggleLoading(true);
        setItems(
          (await Promise.all(refs.map(_ => _.get())))
          .reduce((x, y) => [...x, ...y.docs], [])
          .map(_ => ({ id: _.id, ref: _.ref, ..._.data() }))
        );
      } catch(e) {
        console.log(e, refs);
      } finally {
        toggleLoading(false);
      }
    })();
  }, dependencies);
  return detail ? { items, isLoading } : items;
};
